import React from 'react';
import { Box, Typography } from '@mui/material';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { FaCalendarAlt } from 'react-icons/fa';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import '../../../styles/DateRangePicker.css';

const DateRangeSelector = ({ dateRange, onDateChange }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: 0.5,
      '& .date-range-picker': {
        maxWidth: '300px',
        width: '100%'
      }
    }}>
      <DateRangePicker
        value={dateRange}
        onChange={onDateChange}
        format='MM/dd/yyyy'
        maxDetail='month'
        calendarIcon={<FaCalendarAlt />}
        dayPlaceholder='dd'
        monthPlaceholder='mm'
        yearPlaceholder='yyyy'
        rangeDivider=' to '
        className='date-range-picker'
      />
      <Typography 
        variant='caption' 
        color='text.secondary'
        sx={{ 
          fontSize: '0.75rem',
          lineHeight: 1.2,
          fontStyle: 'italic',
          opacity: 0.8,
        }}
      >
        Optional: Specify date range for progress report data
      </Typography>
    </Box>
  );
};

export default DateRangeSelector; 